var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activeData.accept !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "文件类型" } },
            [
              _c(
                "el-select",
                {
                  style: { width: "100%" },
                  attrs: {
                    clearable: "",
                    "allow-create": "",
                    "collapse-tags": "",
                    multiple: "",
                    placeholder: "请选择文件类型",
                  },
                  model: {
                    value: _vm.activeData.accept,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "accept", $$v)
                    },
                    expression: "activeData.accept",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "图片", value: "image/*" },
                  }),
                  _c("el-option", {
                    attrs: { label: "视频", value: "video/*" },
                  }),
                  _c("el-option", {
                    attrs: { label: "音频", value: "audio/*" },
                  }),
                  _c("el-option", {
                    attrs: { label: "excel", value: ".xls,.xlsx" },
                  }),
                  _c("el-option", {
                    attrs: { label: "word", value: ".doc,.docx" },
                  }),
                  _c("el-option", { attrs: { label: "pdf", value: ".pdf" } }),
                  _c("el-option", {
                    attrs: { label: "ppt", value: ".ppt,.pptx" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.config.fileSize !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "文件大小" } },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入文件大小" },
                  model: {
                    value: _vm.activeData.config.fileSize,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData.config, "fileSize", _vm._n($$v))
                    },
                    expression: "activeData.config.fileSize",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      style: { width: "66px" },
                      attrs: { slot: "append" },
                      slot: "append",
                      model: {
                        value: _vm.activeData.config.sizeUnit,
                        callback: function ($$v) {
                          _vm.$set(_vm.activeData.config, "sizeUnit", $$v)
                        },
                        expression: "activeData.config.sizeUnit",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "KB", value: "KB" } }),
                      _c("el-option", { attrs: { label: "MB", value: "MB" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData["list-type"] !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "列表类型" } },
            [
              _c(
                "el-radio-group",
                {
                  directives: [
                    { name: "removeAriaHidden", rawName: "v-removeAriaHidden" },
                  ],
                  attrs: { size: "mini" },
                  model: {
                    value: _vm.activeData["list-type"],
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "list-type", $$v)
                    },
                    expression: "activeData['list-type']",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "text" } }, [
                    _vm._v(" text "),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeData.config.showTip !== undefined
        ? _c(
            "el-form-item",
            { attrs: { label: "显示提示" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.activeData.config.showTip,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeData.config, "showTip", $$v)
                  },
                  expression: "activeData.config.showTip",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form-item",
        { attrs: { label: "多选文件" } },
        [
          _c("el-switch", {
            model: {
              value: _vm.activeData.multiple,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "multiple", $$v)
              },
              expression: "activeData.multiple",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "文件个数" } },
        [
          _c("el-input-number", {
            model: {
              value: _vm.activeData.limit,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "limit", $$v)
              },
              expression: "activeData.limit",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }